function hasTag(item, tagName) {
    return item.tags?.some((tagGroup) => tagGroup.children?.some((tagChild) => tagChild.name === tagName))
}

const tagKeyMap = [
    { tag: 'los-eip', key: 'eipContentItem' },
    { tag: 'los-bronze', key: 'nonEipContentItem' },
    { tag: 'without-segments', key: 'nonEipContentItem' },
    { tag: 'loyalty-rewards', key: 'loyaltyContentItem' },
]

export function filterContent(content, isEipUser, marketingConsentSubscribed) {
    const mappedContentItems = content.items.reduce((acc, item) => {
        if (item.layoutVariant === 'consent-opted-in') {
            acc.optedInContentItem = item
            return acc
        }

        for (const { tag, key } of tagKeyMap) {
            if (hasTag(item, tag)) {
                acc[key] = item
                break
            }
        }

        return acc
    }, {})

    let marketingCommunicationsItem

    if (marketingConsentSubscribed) {
        marketingCommunicationsItem = mappedContentItems.optedInContentItem
    } else if (isEipUser) {
        marketingCommunicationsItem = mappedContentItems.eipContentItem
    } else {
        marketingCommunicationsItem = mappedContentItems.nonEipContentItem
    }

    let rewardsProgramItem = mappedContentItems.loyaltyContentItem

    return {
        marketingCommunicationsItem,
        rewardsProgramItem,
    }
}
